(function () {
  const MOBILE_QUERY = '(max-width: 767px)';

  function destroySwiper(carousel) {
    if (!carousel?.swiper) return;
    carousel.swiper.destroy(true, true);
  }

  function initExclusiveSection(section) {
    const carousel = section.querySelector('[data-exclusive-carousel]');
    const pagination = section.querySelector('[data-exclusive-pagination]');

    if (!carousel || typeof Swiper === 'undefined') return;

    if (section._exclusiveCleanup) {
      section._exclusiveCleanup();
    }

    const mediaQuery = window.matchMedia(MOBILE_QUERY);

    function syncMode() {
      destroySwiper(carousel);

      if (mediaQuery.matches) {
        new Swiper(carousel, {
          slidesPerView: 1,
          spaceBetween: 0,
          watchOverflow: true,
          resistanceRatio: 0.85,
          pagination: {
            el: pagination,
            clickable: true,
          },
        });
      }
    }

    syncMode();

    mediaQuery.addEventListener('change', syncMode);

    section._exclusiveCleanup = function () {
      destroySwiper(carousel);
      mediaQuery.removeEventListener('change', syncMode);
      section._exclusiveCleanup = null;
    };
  }

  function initAll() {
    document.querySelectorAll('[data-8th-exclusive]').forEach(initExclusiveSection);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', (event) => {
    const section =
      event.target.matches?.('[data-8th-exclusive]')
        ? event.target
        : event.target.querySelector?.('[data-8th-exclusive]');
    if (section) initExclusiveSection(section);
  });
})();
